import { Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { HelpCurationList } from '../help-curation-list/help-curation-list';
import { HelpOdooImport } from '../help-odoo-import/help-odoo-import';

@Component({
  selector: 'lib-help-curation-page',
  imports: [TranslatePipe, HelpCurationList, HelpOdooImport],
  templateUrl: './help-curation-page.html',
  styleUrl: './help-curation-page.scss',
})
export class HelpCurationPage {}
